import React, { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { LoadingScreen } from "Components";
import { CreateField } from "./CreateField";
import { authService } from "Service/Axios";
import { convertLinkObjectListToJoin } from "Utils";
import { DELETE_ADMIN_FIELD_URL, UPDATE_ADMIN_FIELD_URL } from "Constant/api";
import { useFieldList } from "Constant/apiHooks";
import { DESIGN_TYPE_LIST, FEILD_TYPE_LIST } from "Constant/constants";

export const Field = () => {
  const { t } = useTranslation();
  const { projectList } = useOutletContext();

  const [showCreateField, setShowCreateField] = useState(false);
  const [selectedField, setSelectedField] = useState(null);

  const { fieldList, loading: fieldLoading, fetchFieldList } = useFieldList();

  // Toggle
  const toggleCreateField = (attribute) => {
    if (attribute) {
      setSelectedField(attribute);
    } else {
      setSelectedField(null);
    }
    setShowCreateField(!showCreateField);
  };

  // Handle
  const onSaveField = async (field, fieldType, designType) => {
    try {
      const payload = {
        gid: field.gid,
        global: field.global,
        projects: field.projects?.map((option) => option.gid),
        edit: field.edit,
        show: field.show,
        questionName: field.questionName,
        questionLabel: field.questionLabel,
        questionType: fieldType,
        designType: designType,
      };
      const response = await authService(
        UPDATE_ADMIN_FIELD_URL,
        "POST",
        payload
      );
      if (response.success) {
        toast.success(t("common.messages.notification.success.updateField"));
      } else {
        toast.error(response.message);
      }
      fetchFieldList();
    } catch (error) {
      if (error.response && error.response.data) {
        toast.error(error.response.data.message);
      }
    }
  };

  const onDeleteField = async (gid, projectId) => {
    try {
      const data = {
        gid,
        projectId,
      };
      const response = await authService(DELETE_ADMIN_FIELD_URL, "POST", data);
      if (response.success) {
        fetchFieldList();
        toast.success(t("common.messages.notification.success.deleteField"));
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(t("common.messages.notification.failed.somethingWentWrong"));
    }
  };
  return (
    <>
      <div className="fields">
        <div className="d-flex align-items-center mb-3">
          <h4 className="admin-sub-title">{t("common.button.fields")}</h4>
          <div className="ms-auto">
            <button
              className="btn btn-primary"
              type="button"
              onClick={() => toggleCreateField()}
            >
              <i className="bx bx-plus"></i> {t("common.button.createField")}
            </button>
          </div>
        </div>
        <div className="table-container mb-4 max-h-700">
          <table className="table table-bordered">
            <thead className="table-light position-sticky top-0 z-20">
              <tr>
                <th>{t("common.label.field")}</th>
                <th>{t("common.label.label")}</th>
                <th>{t("common.label.projects")}</th>
                <th>{t("common.label.fieldType")}</th>
                <th>{t("common.label.designType")}</th>
                <th className="text-center">{t("common.label.action")}</th>
              </tr>
            </thead>
            <tbody>
              {fieldLoading ? (
                <tr className="loading-screen">
                  <td colSpan={6}>
                    <LoadingScreen />
                  </td>
                </tr>
              ) : (
                fieldList &&
                fieldList.length > 0 &&
                fieldList.map((field, index) => (
                  <tr key={`${field.gid}-${index}`}>
                    <td>{field.questionName}</td>
                    <td>{field.questionLabel}</td>
                    <td>
                      {field.projects &&
                        convertLinkObjectListToJoin(field.projects)}
                    </td>
                    <td>
                      <select
                        className="form-select form-select-sm"
                        aria-label="Default select example"
                        value={field.questionType || ""}
                        onChange={(e) =>
                          onSaveField(field, e.target.value, field.designType)
                        }
                      >
                        <option>- Select -</option>
                        {FEILD_TYPE_LIST.map((fType) => (
                          <option value={fType.key} key={fType.key}>
                            {fType.name}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <select
                        className="form-select form-select-sm"
                        aria-label="Default select example"
                        value={field.designType || ""}
                        onChange={(e) =>
                          onSaveField(field, field.questionType, e.target.value)
                        }
                      >
                        <option>- Select -</option>
                        {DESIGN_TYPE_LIST.map((dType) => (
                          <option value={dType.key} key={dType.key}>
                            {dType.name}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <>
                        <div className="d-flex justify-content-center align-items-center gap-1">
                          <button
                            type="button"
                            className="button edit btn btn-transparent px-1 text-green-500"
                            onClick={() => toggleCreateField(field)}
                          >
                            <i className="bx bxs-pencil"></i>
                          </button>
                          <button
                            type="button"
                            className="button delete btn btn-transparent px-1 text-red-500"
                            onClick={() =>
                              onDeleteField(field.gid, field.projectId)
                            }
                          >
                            <i className="bx bx-trash"></i>
                          </button>
                        </div>
                      </>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showCreateField && (
        <CreateField
          show={showCreateField}
          selectedData={selectedField}
          toggle={toggleCreateField}
          fetchList={fetchFieldList}
          projectList={projectList}
        />
      )}
    </>
  );
};
